"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import Image from "next/image";
import type { MediaBlock as MediaBlockData, Media } from "@/payload-types";
import { cn } from "@/utilities/core/cn";
import { getMediaUrl } from "@/utilities/media/getMediaUrl";
import { MediaCredit } from "@/components/MediaCredit/MediaCredit";
import { MediaCaption } from "@/components/MediaCaption/MediaCaption";
interface MediaBlockBlockProps {
  block: MediaBlockData;
  className?: string;
}

/**
 * Renders a media block from the article content.
 * Supports default and fullscreen positions.
 */
export function MediaBlockBlock(t0) {
  const $ = _c(35);
  const {
    block,
    className
  } = t0;
  const media = block.media as Media | null;
  if (!media?.url) {
    return null;
  }
  const position = block.position ?? "default";
  const isFullscreen = position === "fullscreen";
  const isLeft = position === "left";
  const isRight = position === "right";
  const isFloated = isLeft || isRight;
  let t1;
  if ($[0] !== block.url) {
    t1 = block.url?.trim() || null;
    $[0] = block.url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const href = t1;
  let t2;
  if ($[2] !== block.altOverride || $[3] !== media) {
    t2 = block.altOverride?.trim() || media.alt || "";
    $[2] = block.altOverride;
    $[3] = media;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const altText = t2;
  const captionOverride = block.captionOverride ?? undefined;
  let t3;
  if ($[5] !== isFullscreen || $[6] !== media) {
    t3 = getMediaUrl(media, isFullscreen ? undefined : "xlarge") || media.url;
    $[5] = isFullscreen;
    $[6] = media;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = isFullscreen ? "100vw" : isFloated ? "(max-width: 768px) 100vw, 480px" : "(max-width: 768px) 100vw, 960px";
  let t5;
  if ($[8] !== altText || $[9] !== t3 || $[10] !== t4) {
    t5 = <Image src={t3} alt={altText} fill={true} className="object-cover rounded-lg" sizes={t4} unoptimized={true} />;
    $[8] = altText;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const image = t5;
  const t6 = isFullscreen && "-mx-4 md:-mx-8 lg:-mx-16";
  const t7 = isLeft && "md:float-left md:w-1/2 md:mr-6 md:mt-2";
  const t8 = isRight && "md:float-right md:w-1/2 md:ml-6 md:mt-2";
  let t9;
  if ($[12] !== className || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = cn("mb-4", t6, t7, t8, className);
    $[12] = className;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  const t10 = isFullscreen ? "aspect-21/9" : "aspect-video rounded-lg";
  let t11;
  if ($[17] !== t10) {
    t11 = cn("relative overflow-hidden", t10);
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== href || $[20] !== image) {
    t12 = href ? <a href={href} target="_blank" rel="noopener noreferrer" className="block h-full w-full">{image}</a> : image;
    $[19] = href;
    $[20] = image;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t11 || $[23] !== t12) {
    t13 = <div className={t11}>{t12}</div>;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== captionOverride || $[26] !== media) {
    t14 = <MediaCaption media={media} caption={captionOverride} />;
    $[25] = captionOverride;
    $[26] = media;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== media) {
    t15 = <MediaCredit media={media} className="mt-1 text-right" />;
    $[28] = media;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t9) {
    t16 = <figure className={t9}>{t13}{t14}{t15}</figure>;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t9;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}